import React from 'react';
import { UploadIcon, SpinnerIcon } from '../../../components/Icons';

interface AdminUserCsvUploadSectionProps {
  userCsvFile: File | null;
  onUserCsvFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onProcessUserCsv: () => void;
  onDownloadUserTemplate: () => void;
  isProcessingUserCsv: boolean;
}

export const AdminUserCsvUploadSection: React.FC<AdminUserCsvUploadSectionProps> = ({
  userCsvFile,
  onUserCsvFileChange,
  onProcessUserCsv,
  onDownloadUserTemplate,
  isProcessingUserCsv,
}) => {
  return (
    <div className="mt-12 p-8 bg-gray-50 rounded-3xl border-2 border-dashed border-gray-200">
      <h4 className="text-sm font-black text-gray-800 uppercase tracking-widest mb-4 flex items-center gap-2">
        <UploadIcon className="w-5 h-5 text-sky-600" />
        Carga Masiva (CSV)
      </h4>
      <div className="flex flex-col sm:flex-row items-center gap-4">
        <input
          type="file"
          accept=".csv"
          onChange={onUserCsvFileChange}
          className="block w-full text-sm text-gray-500 file:mr-4 file:py-2.5 file:px-6 file:rounded-xl file:border-0 file:text-xs file:font-black file:bg-sky-100 file:text-sky-700 hover:file:bg-sky-200 cursor-pointer"
          disabled={isProcessingUserCsv}
        />
        <button
          onClick={onProcessUserCsv}
          disabled={!userCsvFile || isProcessingUserCsv}
          className="w-full sm:w-auto px-8 py-2.5 bg-gray-900 text-white rounded-xl text-xs font-black uppercase tracking-widest shadow-lg disabled:opacity-50 transition-all active:scale-95"
        >
          {isProcessingUserCsv ? <SpinnerIcon className="w-4 h-4" /> : 'Procesar CSV'}
        </button>
      </div>
      <div className="mt-4 flex justify-between items-center">
        <p className="text-[10px] text-gray-400 font-medium uppercase tracking-wider">
          Columnas: email, displayName, username, role, status.
        </p>
        <button
          onClick={onDownloadUserTemplate}
          className="text-[10px] font-black text-sky-600 hover:text-sky-800 uppercase tracking-widest underline"
        >
          Descargar Plantilla
        </button>
      </div>
    </div>
  );
};
